import { useContext } from "react";
import { FavoriteProviderContext } from "../favorite-provider.context";

export function useFavorite() {
  return useContext(FavoriteProviderContext);
}
